<template>
<div :class="$style['scrollbar-bar']" :bar="type" gk-scrollbar-bar>
  <gkDrag :touch="touch" :range="thumbRange" auto @move="handleThumbMove">
    <div :class="$style['scrollbar-thumb']" :thumb="type" :style="thumbStyle" gk-scrollbar-thumb></div>
  </gkDrag>
</div>
</template>

<script>
import VueTypes from 'vue-types'

import gkDrag from '../drag/drag'

export default {
  name: 'gkui-scrollbar-thumb',
  components: {
    gkDrag
  },
  props: {
    value: VueTypes.number.def(0),
    scale: VueTypes.number.def(1),
    scrollWidth: VueTypes.number.def(0),
    scrollHeight: VueTypes.number.def(0),
    type: VueTypes.string.def(''),
    touch: VueTypes.bool.def(false)
  },
  data () {
    return {
      width: 0,
      height: 0,
      thumbStyle: {},
      thumbRange: {}
    }
  },
  watch: {
    scale () {
      this.initSize()
    },
    value (value) {
      this.type === 'x' ? this.handleSyncThumbLeft(value) : this.handleSyncThumbTop(value)
    }
  },
  mounted () {
    this.initSize()
  },
  methods: {
    /**
     * 设置 scrollbar 的滚动条样式
     */
    initSize () {
      this.type === 'x' ? this.initX() : this.initY()
    },
    /**
     * 设置 scrollbar X 轴的滚动条样式
     */
    initX () {
      const width = this.$el.clientWidth

      this.width = width

      this.thumbStyle = {
        width: `${width * this.scale}px`
      }

      this.thumbRange = {
        xmin: 0,
        xmax: width - width * this.scale
      }
    },
    /**
     * 设置 scrollbar Y 轴的滚动条样式
     */
    initY () {
      const height = this.$el.clientHeight

      this.height = height

      this.thumbStyle = {
        height: `${height * this.scale}px`
      }

      this.thumbRange = {
        ymin: 0,
        ymax: height - height * this.scale
      }
    },
    /**
     * 滚动条移动时的事件
     */
    handleThumbMove (x, y, left, top, ev) {
      this.type === 'x' ? this.handleSetThumbLeft(left, true) : this.handleSetThumbTop(top, true)
    },
    /**
     * 滚动条 X 轴移动时设置 thumb 样式
     */
    handleSetThumbLeft (left) {
      this.$set(this.thumbStyle, 'left', `${left}px`)

      this.$emit('left', left / (this.width / this.scrollWidth))
    },
    /**
     * 滚动条 Y 轴移动时设置 thumb 样式
     */
    handleSetThumbTop (top) {
      this.$set(this.thumbStyle, 'top', `${top}px`)

      this.$emit('top', top / (this.height / this.scrollHeight))
    },
    /**
     * 同步 scrollbar 的 scrollLeft 值
     */
    handleSyncThumbLeft (left) {
      left = left * (this.width / this.scrollWidth)

      this.$set(this.thumbStyle, 'left', `${left}px`)
    },
    /**
     * 同步 scrollbar 的 scrollTop 值
     */
    handleSyncThumbTop (top) {
      top = top * (this.height / this.scrollHeight)

      this.$set(this.thumbStyle, 'top', `${top}px`)
    }
  }
}
</script>

<style lang="scss" module>

.scrollbar-bar {
  position: absolute; z-index: 10;
}

.scrollbar-thumb {
  position: absolute;
  opacity: 0.7;
  cursor: pointer;
  user-select: none;

  &:after {
    content: '';
    display: block;
    pointer-events: none;
  }

  .scrollbar:hover & {
    opacity: 1;
  }
}
</style>

